import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, resource, signal } from '@angular/core';
import { finalize, lastValueFrom, map } from 'rxjs';
import { LogsService } from '../logs/logs.service';
import { RegionService } from '../region/region.service';

@Injectable({
  providedIn: 'root',
})
export class PricingService {
  http = inject(HttpClient);
  logs = inject(LogsService);
  private readonly regions = inject(RegionService);

  uploadHistory = resource({
    params: () => this.regions.selectedRegionId(),
    loader: ({ params }) =>
      lastValueFrom(this.logs.getLog$('PricingSync', params)),
  });

  noUploadHistory = computed(() => this.uploadHistory.status() === 'error');

  pricingFileUploading = signal<boolean>(false);
  pricingFileUploadError = signal<boolean>(false);
  pricingFileUploadProgress = signal<number | undefined>(undefined);

  uploadPricingFile = (file: File, salesChannelCode: string) => {
    this.pricingFileUploading.set(true);
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http
      .post(
        `Pricing/UploadFile?salesChannelCode=${salesChannelCode}`,
        formData,
        {
          reportProgress: true,
          observe: 'events',
        },
      )
      .pipe(
        map((event) => {
          // Handle download progress as error
          if (event.type === HttpEventType.DownloadProgress) {
            this.pricingFileUploadError.set(true);
          }

          if (
            event.type === HttpEventType.UploadProgress ||
            event.type === HttpEventType.DownloadProgress
          ) {
            const progress = Math.round(
              (100 * event.loaded) / (event.total || 1),
            );
            this.pricingFileUploadProgress.set(progress);
            return progress;
          } else {
            return 0;
          }
        }),
        finalize(() => {
          this.pricingFileUploading.set(false);
          this.pricingFileUploadError.set(false);
        }),
      );
  };

  downloadPricingFile = (deviceCareCenter: string, warehouseCode: string) => {
    const params = new HttpParams()
      .set('DeviceCareCenter', deviceCareCenter)
      .set('WarehouseCode', warehouseCode);

    return this.http.get('Pricing/DownloadFile', {
      responseType: 'blob',
      observe: 'response',
      params,
    });
  };
}
